import _ from 'lodash';
import tinycolor from 'tinycolor2';

import Container from './Container';

class KendoGrid extends Container {
    constructor (container, data, options) {
        super();
        this._export = this._export.bind(this);
        this._excelExport = this._excelExport.bind(this);

        this.category = 'Chart';
        this.options = _.assign({}, { convertTable: true }, options);
        this.dataTable = data;
        this.dataSource = this._createDataSource();

        if (this.options.extended) {
            this.wrapper = container;
        } else {
            this.wrapper = this._createChartWrapper(options);
            $(container).html(this.wrapper.container);
        }

        this._drawChart();
        this._detectScreenChanges();
    }

    _detectScreenChanges () {
        // update chart if orientation or the size of the screen changed
        let callback;
        $(window).resize(() => {
            clearTimeout(callback);
            callback = setTimeout(this._drawChart(), 100);
        });
    }

    _export (btn, name) {
        $(btn).on('click', () => {
            this.table.saveAsExcel();
        });
    }

    _excelExport (e) {
        const name = _.isFunction(this.options.filename) ? this.options.filename() : this.options.filename;
        const filename = String(name) || 'Grid';
        e.workbook.fileName = `${filename}.xlsx`;

        const header = _.isFunction(this.options.exportHeader) ? this.options.exportHeader() : this.options.exportHeader;

        if (!header) {
            return;
        }

        const sheet = _.first(e.workbook.sheets);
        const colSpan = _.size(_.get(_.first(sheet.rows), 'cells')) || 1;

        sheet.rows.unshift({
            height: 40,
            cells: [{
                value: String(header),
                colSpan,
                background: '#37474F',
                color: '#FFFFFF',
                bold: true,
                fontSize: 11,
                fontFamily: 'Calibri',
                textAlign: 'center',
                verticalAlign: 'center'
            }]
        });
    }

    _drawChart () {
        $(this.wrapper.chart).hide();
        $(this.wrapper.table).show();
        if (!this.table) {
            if (this.options.width) {
                $(this.wrapper.table).width(this.options.width);
            }

            const height = this.options.autoheight ? (33 * _.size(this.dataSource.data)) + 35 : this.options.height;

            const options = {
                dataSource: this.dataSource,
                scrollable: _.isBoolean(this.options.scrollable) ? this.options.scrollable : true,
                sortable: _.isBoolean(this.options.sortable) ? this.options.sortable : true,
                filterable: _.isBoolean(this.options.filterable) ? this.options.filterable : true,
                columnMenu: _.isBoolean(this.options.columnMenu) ? this.options.columnMenu : false,
                pageable: false,
                resizable: true,
                excelExport: this._excelExport,
                dataBound: (table) => {
                    if (this.options.autoFitColumn) {
                        const grid = $(this.wrapper.table).getKendoGrid();
                        _.forEach(_.range(0, grid.columns.length), (i) => {
                            grid.autoFitColumn(i);
                        });
                    }

                    if (_.isBoolean(this.options.autocoloring) && this.options.autocoloring) {
                        this._paintCells(table);
                    }

                    if (_.isFunction(this.options.dataBound)) {
                        this.options.dataBound(table);
                    }
                },
                columns: this.options.columns || this._createColumnsStructure(),
                colors: {
                    render: this.options.colorize,
                    options: this.options
                },
                buttons: this.options.buttons
            };

            if (height) {
                options.height = height;
                $(this.wrapper.content).height(height + 20);
            }

            this.table = $(this.wrapper.table).kendoGrid(options).data('kendoGrid');
            $(this.wrapper.table).kendoTooltip({
                filter: ".k-header .k-link",
                content: function(e) {
                    const target = e.target;
                    return target.text();
                }
            });
        } else {
            if (this.options.buttons != undefined && this.options.buttons.fullscreen != undefined && this.options.buttons.fullscreen == true) {
                if ($(".databoard-table").length) {
                    new KendoGrid(".databoard-table", this.dataSource, this.options);
                }
            }

            this.table.refresh();
        }
    }

    _paintCells (table) {
        table = table.sender;
        const { options } = table.options.colors;
        if (!table.options.colors) {
            return;
        }

        const dataTable = [];
        table.thead.find('tr').each((row, rowElem) => {
            row = [];
            $(rowElem).find('th').each((col, colElem) => row.push($(colElem).text()));
            return dataTable.push(row);
        });

        table.tbody.find('tr').each((row, rowElem) => {
            row = [];
            $(rowElem).find('td').each((col, colElem) => row.push($(colElem).text()));
            return dataTable.push(row);
        });

        options.data = dataTable;

        const colors = table.options.colors.render(options);

        return table.tbody.find('tr').each((row, rowElem) =>
            $(rowElem).find('td').each((col, colElem) => {
                if (col > 0) {
                    const bgColor = (colors[row + 1] || {})[col];

                    if (bgColor) {
                        return $(colElem).css({
                            background: bgColor,
                            color: tinycolor(bgColor).isDark() ? '#FFFFFF' : '#1C1C1C'
                        });
                    }
                }
            })
        );
    }

    _createColumnsStructure () {
        if (_.isFunction((this.dataTable || {}).getHeader)) {
            return _.map(this.dataTable.getHeader(), (h, i) => {
                const column = {
                    field: `f_${String(h).toUnderscoreCase()}`,
                    title: String(h)
                };
                if (this.options.percent || this.options.format === 'percent') {
                    column.format = '{0:p1}';
                } else if (this.options.format) {
                    column.format = this.options.format;
                }

                if (i > 0) {
                    column.filterable = false;
                }

                // column.width = 100;

                return column;
            });
        } else {
            return [];
        }
    }

    _createRowsStructure () {
        if (_.isFunction((this.dataTable || {}).getHeader)) {
            const header = this.dataTable.getHeader();
            const rows = [];
            _.forEach(this.dataTable.getAll(), (tb, tbNumber) => {
                return _.forEach(this.dataTable.getRows(0, tbNumber), function (row) {
                    const cell = {};
                    cell[`f_${String(header[0] || '').toUnderscoreCase()}`] = row[0];
                    _.forEach(_.range(1, row.length), i => {
                        cell[`f_${header[i].toUnderscoreCase()}`] = row[i];
                    });
                    return rows.push(cell);
                });
            });
            return rows;
        } else {
            return [];
        }
    }

    _createDataSource () {
        const dataSource = _.isArray((this.dataTable || {}).data) ? this.dataTable : { data: this.options.convertTable ? this._createRowsStructure() : this.dataTable };

        if (this.options.group) {
            dataSource.group = this.options.group;
        }

        return dataSource;
    }
}

export default KendoGrid;



// WEBPACK FOOTER //
// ./src/scripts/core/charts/KendoGrid.js